// extracted by mini-css-extract-plugin
module.exports = {"activeContentTypeContainer":"SearchResultsMobile_activeContentTypeContainer__HsORu","searchResultsBodyContainer":"SearchResultsMobile_searchResultsBodyContainer__PO_sq"};